(ns bp-libs.design-system.components.filter-tabs)

(defn filter-item
  {:storybook {:on-click     {:action  "OnClick"}
               :on-focus     {:action  "OnFocus"}
               :display-name {:name    "Display Name"
                              :type    {:name "string" :required true}
                              :control {:type "text"}}
               :selected?    {:name    "Selected"
                              :type    {:name "boolean"}
                              :control {:type "boolean"}}
               :active?      {:name    "Active"
                              :type    {:name "boolean"}
                              :control {:type "boolean"}}}}
  [{:keys [display-name selected? active? on-click on-focus]}]
  ^{:key display-name}
  [:div {:class ["text-xl font-medium"
                 "py-3 px-7"
                 "cursor-pointer hover:bg-gray-50 hover:text-gray-900 focus:bg-gray-50 focus:text-gray-900 outline-none"
                 (cond
                   active?   "bg-gray-50 text-gray-900"
                   selected? "bg-gray-500 text-gray-50"
                   :else     "bg-gray-900 text-gray-50")
                 "rounded"]

         :tab-index 10
         :on-click on-click
         :on-focus on-focus}
   display-name])
